import ManageTripsDashboardPage from "../../pages/manage-trips/dashboard";
export var ManageTrips_Routes = [
    {
        PATH: '/',
        COMPONENT: ManageTripsDashboardPage,
        isProtected: false,
    },
];
